// Scroll reveal for .lv-reveal elements (fade + rise), ported from the
// Lovable prototype's Reveal component. Progressive enhancement: elements
// are visible by default; this only adds the pre-shown state once JS is
// confirmed running, then reveals on intersection.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var els = document.querySelectorAll('.lv-reveal');
  if (!els.length) return;

  els.forEach(function (el) {
    el.classList.add('lv-reveal-ready');
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lv-reveal-shown');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  els.forEach(function (el) {
    io.observe(el);
  });
})();
